"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = require("../../icons/util/createIcon");
var chartKey_styles_1 = require("./chartKey.styles");
exports.ChartKey = function (props) {
    var keys = props.keys.map(function (key) {
        var shape = key.shape ? key.shape : "circle";
        var fill = key.fill ? key.fill : key.stroke;
        var opacity = key.fillOpacity ? key.fillOpacity : 1;
        return {
            icon: createIcon_1.createIcon({
                shape: shape,
                fill: fill,
                stroke: key.stroke,
                opacity: opacity,
                size: 10,
            }),
            label: key.label,
        };
    });
    return (react_1.default.createElement("div", { className: chartKey_styles_1.chartKeyContainer }, keys.map(function (key, index) { return (react_1.default.createElement("div", { key: index, className: chartKey_styles_1.chartKeyWrapper },
        react_1.default.createElement("div", null, key.icon),
        react_1.default.createElement("div", { "data-qa": "key" }, key.label))); })));
};
